import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import { Routes, Route } from 'react-router-dom'
import { PublicLayout } from './PublicLayout';
import { Profile } from './profile/Profile';
import { Home } from './Home';
import { UserDataService } from './services/UserDataService';

export class Layout extends Component {
    static displayName = Layout.name;
    constructor(props) {
        super(props);
        this.getFileNameForTheme = this.getFileNameForTheme.bind(this);
        this.handleChangeTheme = this.handleChangeTheme.bind(this);
        this.getTheme = this.getTheme.bind(this);
        this.getProfileImage = this.getProfileImage.bind(this);
        this.handleImageChanged = this.handleImageChanged.bind(this);
        this.state =
            {
                theme: props.theme ? props.theme : 'light',
                profileImage: 'profile_image_empty.png'
            };
        this.userDataService = new UserDataService();
        this.getTheme();
        this.getProfileImage();
    }

    getLogoImageFileName(theme) {
        switch (theme) {
            case 'high_contrast':
                return 'logo_tcoe_white_lg.png'
            case 'light':
            default:
                return 'logo_tcoe_black_lg.png';
        }
    }

    getFileNameForTheme() {
        switch (this.state.theme) {
            case 'high_contrast':
                return 'kendo.highcontrast.css';
            case 'urban':
                return 'kendo.urban.css';
            case 'powder':
                return 'kendo.powder.css';
            case 'vintage':
                return 'kendo.vintage.css';
            case 'light':
            default:
                return 'kendo-theme-default-all.css';
        }
    }

    handleChangeTheme(newTheme) {
        this.setState({ theme: newTheme }, () => this.userDataService.setTheme(this.state.theme));
    }

    getTheme() {
        this.userDataService.getTheme()
            .then(data => {
                this.setState({ theme: data.theme || 'light' });
            }, () => {
                // no op
            });
    }

    getProfileImage() {
        this.userDataService.getProfileImage()
            .then(data => {
                if (data.ok) return data.json();
                return Promise.reject(new Error("Unable to get profile image"));
            }, () => {
                return Promise.reject(new Error("Unable to get profile image"));
            })
            .then(json => {
                if (!json.bytes || json.bytes.length === 0)
                    throw new Error("No image data");
                const byteCharacters = atob(json.bytes);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                let blob = new Blob([byteArray], { type: json.mimeType });
                this.setState({ profileImage: window.URL.createObjectURL(blob) });
            }).catch((error) => { console.log(error) });
    }

    handleImageChanged(image) {
        let imageUrl;
        let callback;
        if (!image) {
            console.log('no image');
            imageUrl = 'profile_image_empty.png';
            callback = () => this.userDataService.removeProfilePicture();
        } else {
            console.log('updating image');
            imageUrl = window.URL.createObjectURL(image);
            callback = () => this.userDataService.updateUserImage(image);
        }

        this.setState({ profileImage: imageUrl }, callback);
    }

    render() {
        /* Previously we let the user into the components below and waited for an error. */
        if (!localStorage.getItem('accesstoken')) {
            return (<Routes><Route path="login" component={PublicLayout} /></Routes>);
        }

        return (
            <div>
                <link rel="stylesheet" type="text/css" href="./Components/NavMenu.css" />
                <link id='appliedTheme' type='text/css' rel='stylesheet' href={'/css/' + this.getFileNameForTheme()} />
                <NavMenu profileImage={this.state.profileImage} />
                <Routes>
                    <Route exact path='/' element={<Home />} />
                    <Route exact path='/myphoenix'
                        element={<Profile {...this.props}
                            changeThemeCb={this.handleChangeTheme}
                            theme={this.state.theme}
                            profileImage={this.state.profileImage}
                            handleImageChanged={this.handleImageChanged}
                        />}/>
                </Routes>
                <div id="footerArea" className="margin-top-10 text-center">
                    &copy;{(new Date().getFullYear()) + " - Tulare County Office of Education - Ver. 1.1.3"}
                </div>
            </div>
        );
    }
}
